// 职级 -> 会谈选项
export const zhijiOptionKey = {
  '1': 'A',
  '2': 'B',
  '3': 'C',
  '4': 'D',
  '5': 'E',
  '6': 'F',
  '7': 'G',
  '8': 'H',
  '9': 'I',
  '10': 'J',
  '11': 'K',
  '12': 'L',
}

// 会谈选项 -> 职级
export const formatZhiji = {
  A: '1',
  B: '2',
  C: '3',
  D: '4',
  E: '5',
  F: '6',
  G: '7',
  H: '8',
  I: '9',
  J: '10',
  K: '11',
  L: '12',
}

//  业绩 -> 会谈选项
export const yejiOptionKey = {
  aaa: 'A',
  aa: 'B',
  a: 'C',
  b: 'D',
  c: 'E',
  d: 'F',
}

// 会谈选项 -> 业绩
export const formatYeji = {
  A: 'aaa',
  B: 'aa',
  C: 'a',
  D: 'b',
  E: 'c',
  F: 'd',
}

export const questionType = {
  radio: '单选',
  sort: '点击排序',
  multible: '多选',
}
